import React, { useEffect, useCallback } from 'react';
import Gallery from 'react-photo-gallery';
import GalleryItem from '../components/GalleryItem';

function isInViewport(el) {
	const rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) +
				el.clientHeight &&
		rect.right <=
			(window.innerWidth || document.documentElement.clientWidth)
	);
}
function processLazy() {
	let lazyl = document.querySelectorAll('.lazyl');

	lazyl.forEach((ele, itx) => {
		//console.log(ele,'lazy');
		if (isInViewport(ele)) {
			ele.setAttribute('data-visible', true);
			if (!ele.dataset.loaded) {
				//console.log(ele.dataset.image);
				ele.style.backgroundImage = "url('" + ele.dataset.image + "')";
				ele.setAttribute('data-loaded', true);
			}
		}
	});
}

function addLazy() {
	//console.log("por scroll");
	processLazy();
}

document.addEventListener('DOMContentLoaded', function () {
	//console.log("por domloaded");
	window.addEventListener('scroll', addLazy);
});

export default function GLIFOSCollectionViewer(props) {
	var { apiService, mySelectedPhotos, galleryRef } = props;

	useEffect(() => {
		processLazy();
	});

	useEffect(() => {
		const element = galleryRef.current;
		element.addEventListener('scroll', addLazy);
		return () => element.removeEventListener('scroll', addLazy);
	}, [galleryRef]);

	const imageRenderer = useCallback(
		({ index, left, top, key, photo, ...rest }) => {
			return (
				<GalleryItem
					selected={false}
					key={key ?? index}
					margin={'2px'}
					index={index}
					photo={photo}
					left={left}
					top={top}
					apiService={apiService}
				/>
			);
		},
		[apiService]
	);

	return (
		<div>
			<Gallery
				photos={mySelectedPhotos.payload?.collections ?? []}
				onClick={() => console.log('click en gallery')}
				renderImage={imageRenderer}
			/>
		</div>
	);
}
